import { render, staticRenderFns } from "./admin_list.vue?vue&type=template&id=66a51d36&scoped=true&"
import script from "./admin_list.vue?vue&type=script&lang=js&"
export * from "./admin_list.vue?vue&type=script&lang=js&"
import style0 from "./admin_list.vue?vue&type=style&index=0&id=66a51d36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a51d36",
  null
  
)

export default component.exports